const initialState = {
  show: false,
  text: ''
}
const actionTypes = {
  block: 'blockUI/block',
  unblock: 'blockUI/unblock'
}

function blockUI (text) {
  return { type: actionTypes.block, text }
}
function unblockUI () {
  return { type: actionTypes.unblock }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.block:
      return { ...state, show: true, text: action.text }
    case actionTypes.unblock:
      return { ...state, show: false }
    default: break
  }
  return state
}

export {
  reducer,
  blockUI,
  unblockUI
}



// WEBPACK FOOTER //
// ./src/store/BlockUI.js